import React, { useContext, useEffect, useState } from 'react'

import { Card, CardContent, Grid, makeStyles, Typography, Select, MenuItem, Button, Menu, Avatar } from '@material-ui/core'
import CustomHeading from '../../components/CustomHeading'
import Layout from '../../components/Layout'

import 'react-circular-progressbar/dist/styles.css'

import { UserContext } from '../../context api/UserContext'
import { useRazorPay } from '../../hooks/razorPay/useRazorPay'
import { useSubscription } from '../../hooks/SuperAdmin/useSubscription'
import { isValidUrl } from '../../shared/constants'
import Loader from '../../components/Loader'
import  CustomButton from '../../components/CustomButton'
const useStyles = makeStyles({
  root: {
    backgroundColor: '#F5F8FF',
    justifyContent: 'center',
    border: 'none',
    borderRadius: '10px',
  },
  root1: {
    backgroundColor: '#F6F8FE',
    justifyContent: 'center',
    minWidth: 254,
    minHeight: 390,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    // fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '19px',
    letter: '0.5px',
    margin: "10px",
    color: '#313131',
  },
  title1: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '19px',
    margin: 5,
    color: '#313131',
  },
  text: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '16px',
    color: '#313131',
  },
  text1: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '16px',
    color: '#7B7B7B',
    marginLeft: 20,
    marginRight: 20,
  },
  text2: {
    // fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '15px',
    // padding: "5px",
    marginBottom: "5px",
    lineHeight: '16px',
    color: '#313131',
  },
  drop: {
    width: '70px',
    backgroundColor: 'white',
    border: 'none',
    display: 'flex',
    justifyContent: 'center',
  },
  empty: {
    width: '100%',
    height: '160px',
  },
  bluish: {
    color: '#33499F',
  },
  image: { width: '90px', height: '90px', borderRadius: '8px', objectFit: 'contain' },
  flexBasis: {
    maxWidth: '100%',
  },
  cardGrid: {
    marginLeft: '20px',
  },
  marginZero: {
    marginTop: 0,
    marginLeft: 0,
  },
  title3: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',

    color: '#313131',
    paddingBottom: '10px',
  },
  employeeBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  noMargin: {
    margin: '20px 0 0 0',
  },
  flexGrid: {
    maxWidth: '34.7%',
  },
})

const CompanyActiveSubscription = () => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)

  const startDate = new Date()
  startDate.setDate(1)
  startDate.setHours(0, 0, 0)
  const [from, setFrom] = React.useState(startDate.toISOString())
  const [to, setTo] = React.useState(new Date().toISOString())
  // const { loading, getHomeDashBoard, homeDashBoard } = useDashBoard()
  const { getSubscription, expiringPlans, aboutToExpirePlans, active: subscriptions, activeSubscriptions} = useSubscription()
  const { loadRazorpay, purchaseSubscription, trySubscription} = useRazorPay()
  const user = useContext(UserContext)
  const firstTimeUser = user && user.user && user.user.firstTimeLoggedIn
  console.log({subscriptions})
  console.log({expiringPlans})

  useEffect(() => {
    if (firstTimeUser) {
      setOpen(true)
    }
  }, [firstTimeUser])
  
  useEffect(()=>{
    activeSubscriptions();
    aboutToExpirePlans();
  }, [])

  useEffect(()=>{
  }, [expiringPlans])

  // useEffect(() => {
  //   if(user.user.userType === "COMPANYADMIN"){
  //       getActiveSubscription();
  //   }
  // }, [user])

  
  
        return (
          <Layout heading="Settings" none>
           <Card variant="outlined" className={classes.root}>
            {(expiringPlans || expiringPlans?.trial) && <>
            <br/>
              { expiringPlans ? 
                  <CardContent
                  >
                        <u className = {classes.text2}>Expiring Subscriptions  </u>
                        <br/>
                        <p><span className = {classes.text2}>Subscription Name: {expiringPlans?.subscription?.subscriptionName}<span className = {classes.text2}>{expiringPlans?.trial && "(Trial)"}</span></span>
                        <p className = {classes.text2}>Expiry Date: {expiringPlans?.endDate} </p>
                        <p><span className = {classes.text2}>Allowed Modules</span>: 
                        <Grid container>
                          {expiringPlans?.subscription?.modules?.allowed?.map((item)=>{
                          return( 
                          <Grid item lg = {4} md = {3} sm= {12}>
                            {/* <Card >  */}
                              <CardContent>
                                <b className = {classes.text2}> {item.module}: </b>
                                <br/> 
                                {item.subPermission.map(subP=> {return <>
                                  {subP.toLowerCase()!== 'flag' && subP.toLowerCase() + ", "} <br/> </>})}
                              </CardContent>
                            {/* </Card> */}
                          </Grid>
                          )})}
                        </Grid>
                        </p>
                        <br/>
                        </p>
                        {expiringPlans.trial && <p>
                        <CustomButton 
                            text = "Buy"
                            handleSubmit = {()=> loadRazorpay({amount: expiringPlans.subscription.amount, subscriptionId: expiringPlans.subscription._id, validityPeriod: expiringPlans.subscription.validityPeriod,  purchaseId: expiringPlans._id}) }/>
                        </p>}

                  </CardContent>
               
             
              : <p className = {classes.title }> No Expiring Plans</p>}
            </>
            }
            {!expiringPlans && <p className = {classes.title}>Active Subscriptions </p>}
            {!expiringPlans && subscriptions && subscriptions._id !== expiringPlans?._id ? <CardContent>
                  <p>
                    <span className = {classes.text2}>Subscription Name: {subscriptions?.subscription?.subscriptionName}<span className = {classes.text2}>{subscriptions?.trial && "(Trial)"}</span></span>
                  </p>
                  <p className = {classes.text2}>Expiry Date: {subscriptions?.endDate} </p>
                  <p><span className = {classes.text2}>Allowed Modules</span>: 
                  <Grid container>
                    {subscriptions?.subscription?.modules?.allowed?.map((item)=>{
                    return( 
                    <Grid item lg = {4} md = {3} sm= {12}>
                      {/* <Card >  */}
                        <CardContent>
                          <b className = {classes.text2}> {item.module}: </b>
                          <br/> 
                          {item.subPermission.map(subP=> {return <>
                            {subP.toLowerCase()!== 'flag' && subP.toLowerCase() + ", "} <br/> </>})}
                        </CardContent>
                      {/* </Card> */}
                    </Grid>
                    )})}
                  </Grid>
                  </p>
                   {subscriptions.trial && <p>
                   <CustomButton 
                      text = "Buy"
                      handleSubmit ={()=> {
                        alert(subscriptions)
                        loadRazorpay({amount: subscriptions.subscription.amount, subscriptionId: subscriptions.subscription._id, validityPeriod: subscriptions.subscription.validityPeriod, purchaseId: subscriptions._id})
                      }
                      }/>
                   </p>}
              </CardContent>
          : 
          <p  className = {classes.text1}> No Active Subscriptions Yet</p>}           
          </Card>     
          </Layout>

      );
     
     }

export default CompanyActiveSubscription;